import React from 'react'
import ReactDOM from 'react-dom/client'
import App from './App'
import { BrowserRouter } from 'react-router-dom'
import { UiLanguageProvider } from './i18n'

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <UiLanguageProvider>
      <BrowserRouter>
        <App />
      </BrowserRouter>
    </UiLanguageProvider>
  </React.StrictMode>
)
